export default __webpack_public_path__ + "static/media/true.739298d3.png";